__turbopack_context__.v({
  "dedAmount": "FinanzenPayslipV2-module__Kh7agq__dedAmount",
  "dedBody": "FinanzenPayslipV2-module__Kh7agq__dedBody",
  "dedExpl": "FinanzenPayslipV2-module__Kh7agq__dedExpl",
  "dedIcon": "FinanzenPayslipV2-module__Kh7agq__dedIcon",
  "dedItem": "FinanzenPayslipV2-module__Kh7agq__dedItem",
  "dedLabel": "FinanzenPayslipV2-module__Kh7agq__dedLabel",
  "dedList": "FinanzenPayslipV2-module__Kh7agq__dedList",
  "dedRow": "FinanzenPayslipV2-module__Kh7agq__dedRow",
  "demoRow": "FinanzenPayslipV2-module__Kh7agq__demoRow",
  "demoText": "FinanzenPayslipV2-module__Kh7agq__demoText",
  "featureGrid": "FinanzenPayslipV2-module__Kh7agq__featureGrid",
  "featureIcon": "FinanzenPayslipV2-module__Kh7agq__featureIcon",
  "featureItem": "FinanzenPayslipV2-module__Kh7agq__featureItem",
  "featureSub": "FinanzenPayslipV2-module__Kh7agq__featureSub",
  "featureTitle": "FinanzenPayslipV2-module__Kh7agq__featureTitle",
  "fileName": "FinanzenPayslipV2-module__Kh7agq__fileName",
  "fileRow": "FinanzenPayslipV2-module__Kh7agq__fileRow",
  "flagDesc": "FinanzenPayslipV2-module__Kh7agq__flagDesc",
  "flagTitle": "FinanzenPayslipV2-module__Kh7agq__flagTitle",
  "getGrid": "FinanzenPayslipV2-module__Kh7agq__getGrid",
  "getIcon": "FinanzenPayslipV2-module__Kh7agq__getIcon",
  "getItem": "FinanzenPayslipV2-module__Kh7agq__getItem",
  "getLabel": "FinanzenPayslipV2-module__Kh7agq__getLabel",
  "getValue": "FinanzenPayslipV2-module__Kh7agq__getValue",
  "inlineNote": "FinanzenPayslipV2-module__Kh7agq__inlineNote",
  "optDesc": "FinanzenPayslipV2-module__Kh7agq__optDesc",
  "optEffort": "FinanzenPayslipV2-module__Kh7agq__optEffort",
  "optHead": "FinanzenPayslipV2-module__Kh7agq__optHead",
  "optNext": "FinanzenPayslipV2-module__Kh7agq__optNext",
  "optPer": "FinanzenPayslipV2-module__Kh7agq__optPer",
  "optSaving": "FinanzenPayslipV2-module__Kh7agq__optSaving",
  "optTitle": "FinanzenPayslipV2-module__Kh7agq__optTitle",
  "peerWrap": "FinanzenPayslipV2-module__Kh7agq__peerWrap",
  "previewImg": "FinanzenPayslipV2-module__Kh7agq__previewImg",
  "tipLabel": "FinanzenPayslipV2-module__Kh7agq__tipLabel",
  "tipText": "FinanzenPayslipV2-module__Kh7agq__tipText",
  "tone_brand": "FinanzenPayslipV2-module__Kh7agq__tone_brand",
  "tone_default": "FinanzenPayslipV2-module__Kh7agq__tone_default",
  "tone_red": "FinanzenPayslipV2-module__Kh7agq__tone_red",
  "topActions": "FinanzenPayslipV2-module__Kh7agq__topActions",
  "uploadActions": "FinanzenPayslipV2-module__Kh7agq__uploadActions",
});
